import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogGeneral } from 'app/dialogs/DialogGeneral';

export interface DialogConfirmData {
    title: string;
    message: string;
}

@Component({
    selector: 'dialog-confirm',
    templateUrl: 'dialog-confirm.html',
    styleUrls: ['dialog-confirm.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class DialogConfirm extends DialogGeneral {
    constructor(
        public dialogRef: MatDialogRef<DialogConfirm>,
        @Inject(MAT_DIALOG_DATA) public data: DialogConfirmData
    ) {
        super(dialogRef);
    }
}
